<template>
    <v-layout>
        <patient-navigation/>

        <v-container
            fluid
            container fill-height
        >
            <v-layout align-center justify-center column v-if="init">
                <h1>{{ $t('poll')}} {{ selectedPoll.name }}</h1>
                <h2 class="mb-4">{{$t('patient')}}</h2>
                <div v-if="selectedPoll.completed">
                    <v-card-title>
                        <v-layout column mt-4>
                            <v-flex pa-2 class="text-xs-center">
                                <h2>{{$t('pollCompleted')}}</h2>
                            </v-flex>
                            <v-flex px-2>
                                <span class="title">{{$t('pollCompletedMessage')}}</span>
                                <p v-if="completedNextUrl">
                                    {{$t('followUpCompletedNextMessage')}}<br>
                                    <a :href="completedNextUrl">{{$t('followUpCompletedNextMessageClickHere')}}</a>
                                </p>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                </div>
                <template v-else>
                    <v-btn color="primary" text @click="start()" v-if="!startScore">
                        {{ $t('start') }}
                    </v-btn>
                    <patient-poll-score-view
                        v-if="startScore">
                    </patient-poll-score-view>
                </template>
            </v-layout>
        </v-container>
    </v-layout>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex';
import PatientNavigation from "../../components/patients/PatientNavigation";
import PatientMedicalCaseForm from "../../components/patients/medicalCases/PatientMedicalCaseForm";
import axios from 'axios'
import PatientPollScoreView from "../../components/patients/score/PatientPollScoreView.vue";

export default {
    name: "PatientPoll",
    components: {
        PatientMedicalCaseForm,
        PatientNavigation,
        PatientPollScoreView
    },
    data() {
        return {
            sign: null,
            init: false,
            startScore: false,
        }
    },
    mounted() {
        this.setSelectedPatientId(this.$route.params.patient_id)
        this.setSelectedPollId(this.$route.params.poll_id)
        this.sign = this.$route.params.hash
        this.openPollFromNotification({signature: this.sign, concern: this.concern, axios: axios}).then(response => {
            this.setSelectedPoll(response.data.poll)
            this.setCompletedNextUrl(response.data.next_link)
            this.setNextUrl(response.data.next_route)
            this.setLastUrl(response.data.previous_route)
            this.setCompleted(response.data.completed)

            if (this.completedNextUrl) {
                setTimeout(this.redirectToNext,5000)
            }

            this.init = true;

        }).catch(reason => {
            //Stay here..
        })
    },
    computed: {
        ...mapState('polls', {
            selectedPoll: state => state.selectedPoll,
            nextUrl: state => state.nextUrl,
            lastUrl: state => state.lastUrl,
            completedNextUrl: state => state.completedNextUrl,
        })

    },
    methods: {
        ...mapActions('polls', ['openPollFromNotification']),
        ...mapMutations('polls', [
            'setSelectedPollId',
            'setSelectedPoll',
            'setCompletedNextUrl',
            'setNextUrl',
            'setLastUrl',
            'setCompleted'
        ]),
        ...mapMutations('patients', [
            'setSelectedPatientId'
        ]),
        start() {
            this.startScore = true
        },
        redirectToNext() {
            window.location.href = this.completedNextUrl
        }
    }
}
</script>

<style scoped>

</style>
